// extracted by mini-css-extract-plugin
export default {"loader":"CircularSpinner_loader__WldHn","load6":"CircularSpinner_load6__bby79","round":"CircularSpinner_round__bqBmL"};